//@flow
import { CONFIRMATION_MESSAGE } from "./constants"

export const confirmDeletePath = (id: string): Object => ({
  pathname: `/admin/attract-loops/${id}/confirm/delete`,
  state: {
    modal: true,
    successPath: "/admin/attract-loops/",
    message: CONFIRMATION_MESSAGE
  }
})



// WEBPACK FOOTER //
// ./src/AttractLoops/helpers.js